import { defineMessages } from 'react-intl';
import {
  addMapTemplateOptions,
  addLinkMoreOptions,
  addSchemaField,
} from 'design-comuni-plone-theme/config/Blocks/ListingOptions';

const messages = defineMessages({
  show_map_filters_subjects: {
    id: 'show_map_filters_subjects',
    defaultMessage: 'Mostra i filtri per categoria',
  },
});

export const changeMapTemplateOptions = (blocksConfig) => {
  blocksConfig.blocksConfig.listing.variations.filter(
    (v) => v.id === 'mapTemplate',
  )[0].schemaEnhancer = ({ schema, formData, intl }) => {
    let pos = addMapTemplateOptions(schema, formData, intl); // aggiungo i campi di default di io-comune
    addSchemaField(
      schema,
      'show_map_filters_subjects',
      intl.formatMessage(messages.show_map_filters_subjects),
      null,
      { type: 'boolean' },
      pos,
    );
    addLinkMoreOptions(schema, formData, intl);
    return schema;
  };
};
